import React, { useState } from 'react';
import { CheckCircle2, Loader2, Send } from 'lucide-react';
import { misc } from '../services/api';

const EMPTY = { name: '', email: '', message: '', website: '' };
const field = 'w-full rounded-lg bg-neutral-800 border border-neutral-700 px-3 py-2 text-sm text-white placeholder:text-neutral-400 focus:outline-none focus:border-green-500';

export const FooterContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState('sending'); setError('');
    try { await misc.contact(form); setState('sent'); setForm(EMPTY); }
    catch (err) { setError(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || 'Something went wrong. Please try again.'); setState('idle'); }
  };

  if (state === 'sent') return (
    <div className="rounded-xl border border-green-600/40 bg-green-600/10 p-4" data-testid="contact-success">
      <div className="flex items-center gap-2 text-white font-semibold"><CheckCircle2 size={18} className="text-green-400"/> Message sent!</div>
      <p className="mt-1 text-sm text-neutral-200">Thanks for reaching out. Our team will reply to your email soon.</p>
      <button type="button" onClick={() => setState('idle')} className="mt-3 text-xs text-green-400 hover:text-green-300 underline" data-testid="contact-send-another">Send another message</button>
    </div>
  );

  return (
    <form onSubmit={submit} className="space-y-2" data-testid="contact-form">
      <input required maxLength={120} placeholder="Your name" value={form.name} onChange={set('name')} className={field} data-testid="contact-name"/>
      <input required type="email" placeholder="Email address" value={form.email} onChange={set('email')} className={field} data-testid="contact-email"/>
      <textarea required minLength={5} maxLength={5000} rows={3} placeholder="Your message" value={form.message} onChange={set('message')} className={`${field} resize-none`} data-testid="contact-message"/>
      <input tabIndex={-1} autoComplete="off" value={form.website} onChange={set('website')} className="hidden" aria-hidden="true"/>
      {error && <p className="text-xs text-red-300" data-testid="contact-error">{String(error)}</p>}
      <button disabled={state === 'sending'} data-testid="contact-submit"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-600 hover:bg-green-500 disabled:opacity-60 text-white text-sm font-semibold transition-colors">
        {state === 'sending' ? <Loader2 size={14} className="animate-spin"/> : <Send size={14}/>} Send message
      </button>
    </form>
  );
};
